import axios, { AxiosResponse } from 'axios';

import { getAccountAdminEndpoint } from 'rdx/config';
import { proxy } from 'service/shared';
import { CLIENT_CODE, SESSION_KEY } from 'utils';

import { AccountAdminResponse, GetUserRightsResponse } from './types';

const AAinstance = axios.create({
  baseURL: `${proxy}${getAccountAdminEndpoint()?.url}`,
});

AAinstance.interceptors.request.use((config) => ({
  ...config,
  headers: {
    sessionKey: localStorage.getItem(SESSION_KEY),
    clientCode: localStorage.getItem(CLIENT_CODE),
  },
}));

export const getAccountAdminUserRights = async (): Promise<
  AxiosResponse<AccountAdminResponse<GetUserRightsResponse>>
> => AAinstance.get('/v1/user/rights');
